import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { inject, observer } from "mobx-react";
import { Form, Row, Col, Typography, Card, Empty, Tooltip } from "antd";
import * as Yup from "yup";
import moment from "moment";
import { dateTimeFormat } from "constant/constant";
import FromInputWithButton from "components/FormItems/FormInputWithButton";

function UserSpecialPlans(props) {
  const { user, userStore } = props;
  const [userPlan, setUserPlan] = useState();
  const { addSpecialPlanToUser, fetchSpecialPlansByUser, deleteUserSpecialPlan } = userStore;

  useEffect(() => {
    fetchPlans();
  }, [user]);

  function fetchPlans() {
    fetchSpecialPlansByUser({ userId: user?._id }).then(({ data }) => {
      if (data.plan) setUserPlan(data.plan);
    });
  }

  function deletePlan({ userId, planId }) {
    deleteUserSpecialPlan({ userId, planId }).then(() => setUserPlan());
  }
  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Formik
            initialValues={{ centsPerCredit: 0 }}
            validationSchema={Yup.object().shape({
              centsPerCredit: Yup.number()
                .min(1, "Number must be greater than 0")
                .required("Number is required!")
            })}
            onSubmit={values => {
              addSpecialPlanToUser({ user, ...values }).then(fetchPlans);
            }}
          >
            {({ values, errors, touched, handleChange, handleSubmit, isSubmitting }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <FromInputWithButton
                    inputProps={{
                      placeholder: "CENTS PER CREDIT",
                      value: values.centsPerCredit,
                      onChange: handleChange,
                      name: "centsPerCredit",
                      type: "number",
                      step: "0.01",
                      error: errors.centsPerCredit,
                      touched: touched.centsPerCredit
                    }}
                    buttonProps={{
                      type: "submit",
                      label: "Add Plan"
                    }}
                  />
                </Form>
              );
            }}
          </Formik>
        </Col>
        <Col span={24}>
          <Typography.Text strong>Active Plans</Typography.Text>
        </Col>
        <Col md={8} sm={12}>
          {userPlan ? (
            <Card className="rounded" hoverable>
              <Row gutter={20} type="flex" align="middle">
                <Col md={18}>
                  <Typography.Text strong>{parseFloat(userPlan.centsPerCredit)} cents/credit</Typography.Text>
                  <br />
                  <Typography.Text>{moment(userPlan.createdAt).format(dateTimeFormat)}</Typography.Text>
                </Col>
                <Col md={6}>
                  <Tooltip placement="top" title="Delete Plan">
                    <i
                      className="fas fa-trash-alt text-danger-color fs-5"
                      onClick={() =>
                        deletePlan({
                          userId: userPlan.user,
                          planId: userPlan._id
                        })
                      }
                      type="button"
                    />
                  </Tooltip>
                </Col>
              </Row>
            </Card>
          ) : (
            <Card hoverable className="rounded">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Plans Added Yet!" />
            </Card>
          )}
        </Col>
      </Row>
    </>
  );
}

export default inject(stores => ({
  userStore: stores.store.userStore
}))(observer(UserSpecialPlans));
